import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { Popup } from '@shared/ui';

import cls from './PositionItem.module.css';
import { planFactHelper } from '../../../../../helpers/planFactHelper';
import { useEditPosition } from '../../../../../hooks/useEditPosition';
import { Badge } from '../../../../UI/Badge/Badge';
import s from '../../../../UI/DateInput/DataInput.module.css';
import { DateInput } from '../../../../UI/DateInput/DateInput';
import { DayInput } from '../../../../UI/DayInput/DayInput';
import { DonePosition } from '../../../../UI/DonePosition/DonePosition';

export const PositionItem = ({ position, parentNumber }) => {
    const {
        resetPosition,
        createPosition,
        decreasePosition,
        increasePosition,
        onDataPickerPosition,
    } = useEditPosition(position);

    const [positionForm, setPositionFormForm] = useState({
        date: position.planned.start_date ? moment(position.planned.start_date).format() : null,
        days: position.planned.days_count ? position.planned.days_count : '',
    });

    const [isShowPopup, setState] = useState(false);

    const onChangePopup = (state) => {
        if (isPlanFact) {
            setState(state);
        }
    };

    const { settings } = useSelector((state) => state.gantReducer);

    const isShowPosition = !settings.isShowMHD && position?.type !== 'labor';

    const isNotNeedCreatePosition = position?.planned.start_date !== null;

    const pickerEndDate = positionForm.date
        ? moment(positionForm.date)
              .add(+positionForm.days - 1, 'days')
              .format('DD.MM.YYYY')
        : moment(Date.now()).format('DD.MM.YYYY');

    useEffect(() => {
        setPositionFormForm({
            date: position.planned.start_date ? moment(position.planned.start_date).format() : null,
            days: position.planned.days_count ? position.planned.days_count : '',
        });
    }, [position]);

    if (!position || isShowPosition) {
        return null;
    }

    const onDateChange = (value) => {
        const isToConnectionsTypeOne = position.connections.some(
            (connection) => connection.type === 1 && position.guid === connection.to
        );
        const isToConnectionsTypeTwo = position.connections.some(
            (connection) => connection.type === 0 && position.guid === connection.to
        );

        const isUnchangeable = isToConnectionsTypeOne && isToConnectionsTypeTwo;

        if (isUnchangeable) {
            return;
        }
        setPositionFormForm((prevState) => ({ ...positionForm, days: value }));
    };

    const onSubmit = () => {
        if (positionForm.days === '0' || !positionForm.days) {
            resetPosition();
            return;
        }
        if (isNotNeedCreatePosition) {
            const newEndDate = moment(positionForm.date).add(+positionForm.days - 1, 'days');
            const oldEndDate = moment(position.planned.end_date);
            const isDecrease = newEndDate.isBefore(oldEndDate);
            const differenceInDays = Math.abs(oldEndDate.diff(newEndDate, 'days'));

            if (isDecrease) {
                decreasePosition(differenceInDays);
            } else {
                increasePosition(differenceInDays);
            }
        } else {
            createPosition(positionForm);
        }
    };

    const onPaymentDateChangeCancel = () => {
        resetPosition();
    };
    const onPaymentDateChange = ({ start, end }) => {
        const isToConnectionsTypeOne = position.connections.some(
            (connection) => connection.type === 1 && position.guid === connection.to
        );
        const isToConnectionsTypeTwo = position.connections.some(
            (connection) => connection.type === 0 && position.guid === connection.to
        );

        const isUnchangeable = isToConnectionsTypeOne && isToConnectionsTypeTwo;

        if (isUnchangeable) {
            return;
        }

        const startDate = moment(start);
        const endDate = moment(end);
        const duration = moment.duration(endDate.diff(startDate));
        const days = `${Math.round(+duration.asDays())}`;

        if (isNotNeedCreatePosition) {
            onDataPickerPosition(position, { start, end, days });
        } else {
            createPosition({ days, date: moment(start).format() });
        }
    };

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!position.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    const { isNotEqualDate, isNotEqualDays, isRedDate, isRedDays } = planFactHelper(
        position.planned,
        position.actual,
        isPlanFact
    );

    return (
        <div className={classNames(cls.PositionItem, { [cls.factWrapper]: isPlanFact })}>
            <Popup
                isOpen={isShowPopup}
                contentText={i18next.t('PositionItem.return.Popup.text')}
                onHidePopup={() => onChangePopup(false)}
                type="alert"
            />
            {parentNumber ? (
                <div className={classNames(cls.numberBlock)}>{position.number}</div>
            ) : (
                <div className={cls.singlePosition}>{position.number}</div>
            )}
            <div className={classNames(cls.title, { [cls.singlePositionName]: !parentNumber })}>
                <div className={cls.titleContent}>
                    {position.name}
                    {isPlanFact && <DonePosition isDone={position.done_percent >= 100} />}
                </div>
                {position.is_canceled && (
                    <Badge>{i18next.t('PositionItem.return.title.titleContent.Badge')}</Badge>
                )}
            </div>
            <div className={classNames(cls.capacity)}>
                <span>
                    {position.quantity} {position.unit}
                </span>
            </div>
            <div className={classNames(cls.dateBlock)} onClick={() => onChangePopup(true)}>
                {isPlanFact ? (
                    <>
                        {position.planned.start_date ? (
                            <span className={classNames(cls.factDate)}>
                                {moment(position.planned.start_date).format('DD.MM.YYYY')}
                            </span>
                        ) : (
                            <div className={classNames(s.svgWrapper)}>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M16.25 5H3.25V17H16.25V5Z" stroke="#757575" />
                                    <path d="M7.25 3H5.25V7H7.25V3Z" stroke="#757575" />
                                    <path
                                        d="M16.5 8.75H3V9.25H16.5V8.75Z"
                                        stroke="#757575"
                                        strokeWidth="0.5"
                                    />
                                    <path d="M14.25 3H12.25V7H14.25V3Z" stroke="#757575" />
                                </svg>
                            </div>
                        )}
                    </>
                ) : (
                    <DateInput
                        classes={[cls.positionDateInput, cls.input]}
                        key={Math.random()}
                        isRequired
                        date={positionForm.date}
                        parameterName="datePlan"
                        newCallbackNotSingle={onPaymentDateChange}
                        newCallbackNotSingleCancel={onPaymentDateChangeCancel}
                        options={{
                            startDate: positionForm.date
                                ? moment(positionForm.date).format('DD.MM.YYYY')
                                : moment(Date.now()).format('DD.MM.YYYY'),
                            endDate: pickerEndDate,
                            autoUpdateInput: true,
                            singleDatePicker: false,
                            showDropdowns: true,
                            autoApply: false,
                        }}
                    />
                )}

                {isPlanFact && isNotEqualDate && (
                    <span className={classNames(cls.secondary, { [cls.fact]: isRedDate })}>
                        {moment(position?.actual?.start_date).format('DD.MM.YYYY')}
                    </span>
                )}
            </div>
            <div className={classNames(cls.daysBlock)} onClick={() => onChangePopup(true)}>
                {isPlanFact ? (
                    <>
                        {position.planned.days_count ? (
                            <span>{position.planned.days_count}</span>
                        ) : (
                            <span style={{ color: '#ADB0B5' }}>0</span>
                        )}
                    </>
                ) : (
                    <DayInput
                        value={positionForm.days}
                        onChange={onDateChange}
                        onSubmit={onSubmit}
                        classes={cls.positionDateInput}
                    />
                )}

                {isPlanFact && isNotEqualDays && (
                    <span className={classNames(cls.secondary, { [cls.fact]: isRedDays })}>
                        {position.actual?.days_count}
                    </span>
                )}
            </div>
        </div>
    );
};
